import { useMemo } from "react";
import { useQuery } from "react-query";

import { fetchCanReceiveDmBatch } from "@/react/api/canReceiveDmBatchApi";

const CAN_RECEIVE_DM_BATCH_QUERY_KEY = "can-receive-dm-batch";

export const useCanReceiveDmBatch = (communityMemberIds: number[]) => {
  const sortedIdsKey = useMemo(
    () => [...communityMemberIds].sort((a, b) => a - b).join(","),
    [communityMemberIds],
  );

  const { data, isInitialLoading } = useQuery({
    queryKey: [CAN_RECEIVE_DM_BATCH_QUERY_KEY, sortedIdsKey],
    queryFn: () => fetchCanReceiveDmBatch(communityMemberIds),
    enabled: communityMemberIds.length > 0,
  });

  const canReceiveDmByMemberId = useMemo(() => {
    if (!data) return undefined;
    return data.reduce<Record<number, boolean>>((acc, item) => {
      acc[item.community_member_id] = item.can_receive_dm_from_current_member;
      return acc;
    }, {});
  }, [data]);

  return { canReceiveDmByMemberId, isLoading: isInitialLoading };
};
